import { render, staticRenderFns } from "./Top-Off-Plans-Subscriber.vue?vue&type=template&id=474434ac&scoped=true"
import script from "./Top-Off-Plans-Subscriber.vue?vue&type=script&lang=js"
export * from "./Top-Off-Plans-Subscriber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "474434ac",
  null
  
)

export default component.exports